import { locations } from "../../common/redux/action_locations";
import {
	FETCH_AGENT_SCHEDULE,
	FETCH_MANAGEMENT_UNIT,
	FETCH_TEAM,
    WEEKLY_SCHEDULE_RECEIVED,
    TEAM_RECEIVED,
	MANAGEMENT_UNIT_RECEIVED,
	DATE_SELECTED
} from "./constants";
import moment from "moment-timezone";
import { CFAuthGetRef } from "auth";

function fetchAgentSchedule(filters) {
    return CFAuthGetRef({
        url:
            process.env.REACT_APP_WFM_API_URL +
            `/AgentSchedule/${filters.agentID}`,            
        params: filters,
        originURL: process.env.PUBLIC_URL,
        loaderName: "fetchSchedule"
    });
}

function fetchTeamByID(filters) {
    return CFAuthGetRef({
        url: process.env.REACT_APP_DATA_PROXY_API_URL + `/CCMProxy/GetTeam`,
        params: filters,
        originURL: process.env.PUBLIC_URL,
        loaderName: "fetchTeam"
    });
}
function fetchMUByID(filters) {
    return CFAuthGetRef({
        url: process.env.REACT_APP_DATA_PROXY_API_URL + `/CCMProxy/GetManagementUnit`,
        params: filters,
        originURL: process.env.PUBLIC_URL,
        loaderName: "fetchMU"
    });
}

export function receivedAgentScheduleAction(data) {
    if(data.Events && data.Events.length > 0){
        data.Events.forEach(element => {

            var momentScheduleDayKey = moment.tz(element.ScheduledDayKey, 'YYYY-MM-DD', 'America/New_York')
            var startTime = moment.tz(element.StartTime, 'HH:mm', 'America/New_York').clone();		
            var endTime = moment.tz(element.EndTime, 'HH:mm', 'America/New_York').clone();		
            
            element.StartTime  = momentScheduleDayKey.clone().set({
                                    'hour': startTime.get('hour'),
                                    'minute'  : startTime.get('minute'), 
                                    'second' : startTime.get('second')
                                }).local();
            element.EndTime  = momentScheduleDayKey.clone().set({
                                    'hour': endTime.get('hour'),
                                    'minute'  : endTime.get('minute'), 
                                    'second' : endTime.get('second')
                                }).add(1,'minutes').local();
            element['isWrapAround'] = false;
            if(minutesOfDay(element.StartTime.local()) > minutesOfDay(element.EndTime.local()))
                    element['isWrapAround'] = true;
            if(element.StartTime.local() > element.EndTime.local()){
                element.EndTime = element.EndTime.clone().add(1, 'days')            
            }      
            
        });        
        data.Events = data.Events.groupBy('ScheduledDayKey')                
    }   
	return {
		type: WEEKLY_SCHEDULE_RECEIVED,
		schedule: data		     
	};
}

export function receivedTeamAction(data) {
    return {
        type: TEAM_RECEIVED,
        team: data
    };
}
export function receivedMUAction(data) {
    return {
        type: MANAGEMENT_UNIT_RECEIVED,
        mu: data
    };
}

export function fetchAgentScheduleAction(filters) {
    return {
        type: FETCH_AGENT_SCHEDULE,
        fetchCall: fetchAgentSchedule,
        receivedAction: receivedAgentScheduleAction,
        data: {
            filters,
            locations
        }
    };
}

export function fetchMUAction(filters) {
	return {
        type: FETCH_MANAGEMENT_UNIT,
        fetchCall: fetchMUByID,
        receivedAction: receivedMUAction,
        data: {
            filters,
            locations
        }
    };
}

export function fetchTeamAction(filters) {
	return {
        type: FETCH_TEAM,
        fetchCall: fetchTeamByID,
        receivedAction: receivedTeamAction,
        data: {
            filters,
            locations
        }
    };
}

export function selectedDateAction(startDate, endDate, selectedDate) {
	return {
        type: DATE_SELECTED,
		selectedStartDate: startDate,
        selectedEndDate: endDate,
        selectedDate: selectedDate
    };
}

export function reducer(state, action) {
    switch (action.type) {
        case WEEKLY_SCHEDULE_RECEIVED:
            return {
                ...state,
                Schedule: action.schedule
            };
        case TEAM_RECEIVED:
            return {
                ...state,
                Team: action.team
            };
        case MANAGEMENT_UNIT_RECEIVED:
            return {
                ...state,
                ManagementUnit: action.mu
			};
			
		case DATE_SELECTED:
		return {
			...state,
			selectedStartDate: action.selectedStartDate,
            selectedEndDate: action.selectedEndDate,
            selectedDate: action.selectedDate
		}
        default:
            return state;
    }
}

Array.prototype.groupBy = function(prop) {
    return this.reduce(function(groups, item) {
        const val = item[prop];
        groups[val] = groups[val] || [];
        groups[val].push(item);
        return groups;
    }, {});
};

function minutesOfDay(m){
    return m.minutes() + m.hours() * 60;
  }


// WEBPACK FOOTER //
// ./src/features/schedules/redux/weekly_schedule_actions.js